import { GET_BILLING, GET_BILLINGAPPROVAL } from "resources/actionTypes";

export function getBilling(payload) {
  return {
    type: GET_BILLING.GET_BILLING_REQUESTED,
    payload: payload
  };
}
export function getBillingApproval(payload, setSelectedCheckRows) {

  const payloadData = {
    formPayload: payload,
    handleSelectedRows: setSelectedCheckRows
  }
  return {
    type: GET_BILLINGAPPROVAL.GET_BILLINGAPPROVAL_REQUESTED,
    payload:  payloadData
   
  };
}

